import Icon from '../components/Icon.vue'

Icon.register({
  snowman: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M510.9 152.3L505 137.8C501.7 129.8 492.4 125.9 484.2 129.1L456 140.6V111.6C456 103 448.8 96 440 96H424C415.2 96 408 103 408 111.6V158.5C408 159 408.3 159.5 408.3 160L351.9 183C346 173 338.6 164.1 329.9 156.4 343.5 139.8 351.9 119 351.9 95.9 351.9 42.9 308.9-0.1 255.9-0.1S159.9 42.9 159.9 95.9C159.9 119 168.4 139.8 181.9 156.4 173.2 164.1 165.9 173 159.9 183L103.5 160C103.6 159.5 103.8 159 103.8 158.5V111.6C104 103 96.8 96 88 96H72C63.2 96 56 103 56 111.6V140.6L27.9 129.1C19.7 125.9 10.4 129.8 7.1 137.8L1.2 152.3C-2.1 160.3 1.9 169.4 10.1 172.6L145.3 227.8C144.9 231.8 144.1 235.8 144.1 240 144.1 250.1 145.8 259.6 148.3 268.9 120.9 296.4 104 334.2 104 376 104 430 132.4 476.9 174.8 503.8 184.1 509.7 195.1 512 206.1 512H305.3C318.6 512 331.6 507.9 342.5 500.3 389 468 416.9 410.9 405.4 347.7 399.9 317.5 384.9 290.1 363.8 268.7 366.3 259.5 368 250 368 240 368 235.8 367.2 231.9 366.8 227.8L502 172.6C510.1 169.5 514.1 160.4 510.9 152.3zM224 96C215.2 96 208 88.8 208 80S215.2 64 224 64 240 71.2 240 80 232.8 96 224 96zM256 368C247.2 368 240 360.8 240 352S247.2 336 256 336 272 343.2 272 352 264.8 368 256 368zM256 304C247.2 304 240 296.8 240 288S247.2 272 256 272 272 279.2 272 288 264.8 304 256 304zM256 240C247.2 240 240 232.8 240 224S247.2 208 256 208 272 215.2 272 224 264.8 240 256 240zM256 152S240 128.8 240 120 247.2 104 256 104 272 111.2 272 120 256 152 256 152zM288 96C279.2 96 272 88.8 272 80S279.2 64 288 64 304 71.2 304 80 296.8 96 288 96z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/snowman.js
// module id = uZ/x
// module chunks = 144